import cx from 'classnames'
import { motion, useAnimation } from 'framer-motion'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import PageLink from '../PageLink'
import './styles.scss'

const NextPageOffer = ({ to, title }) => {
  const [isPressed, setIsPressed] = useState(false)
  const [navigate, setNavigate] = useState(false)

  const containerRef = useRef(null)

  const animation = useAnimation()

  const animationVariants = {
    x: '0%',
    transition: { duration: 8, ease: 'linear' }
  }

  const accelerateCountdown = () => {
    setIsPressed(true)
    animation.start({ ...animationVariants, transition: { duration: 0.8, ease: 'linear' } })
  }

  const decelerateCountdown = () => {
    setIsPressed(false)
    animation.start({ x: '-100%', transition: { duration: 0.3, ease: 'linear' } })
  }

  const onAnimationUpdate = latest => {
    latest.x === '0%' && setNavigate(true)
  }

  return (
    <div
      className="next-page-offer"
      ref={containerRef}
      onMouseDown={accelerateCountdown}
      onTouchStart={accelerateCountdown}
      onMouseUp={decelerateCountdown}
      onTouchEnd={decelerateCountdown}
    >
      <motion.div
        className="next-page-offer__progress"
        initial={{ x: '-100%' }}
        animate={animation}
        onUpdate={onAnimationUpdate}
      />
      <div
        className={cx({
          'next-page-offer__title': true,
          'is-pressed': isPressed
        })}
      >
        {title}
      </div>
      <div className="next-page-offer__link">
        <PageLink to={to} navigate={navigate}>
          Versteckter Link
        </PageLink>
      </div>
    </div>
  )
}

NextPageOffer.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default NextPageOffer
